import { getCheckoutData } from "@/components/Checkout/handlers";
import { getCurrentUserToken } from "@/lib/auth";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router";
import { useAuth } from "reactfire";

export const CHECKOUT_DATA_QUERY_KEY = "checkout-data";

export function useCheckoutDataQuery() {
  const auth = useAuth();
  const [searchParams] = useSearchParams();

  const appLang = searchParams.get("lang") || "en";
  const referrer = searchParams.get("referrer");
  const promoCode =
    searchParams.get("promo_code") || searchParams.get("promoCode");

  return useQuery({
    // No country key: `/pricing/metadata` takes no country param and localises
    // off the bearer token, so keying on it only forced an identical refetch.
    queryKey: [CHECKOUT_DATA_QUERY_KEY, appLang, referrer, promoCode],
    queryFn: async () => {
      const token = await getCurrentUserToken();

      if (!token) throw new Error("No auth token");

      const checkoutData = await getCheckoutData({
        appLang,
        referrer: referrer || null,
        promoCode: promoCode || null,
        token,
      });

      return checkoutData;
    },
    enabled: !!auth.currentUser?.uid,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
}
